/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Start_HInputs */

const en_wc_tut_start_h = /** @type {(inputs: Wc_Tut_Start_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Install and open a document`)
};

/**
* | output |
* | --- |
* | "1. Install and open a document" |
*
* @param {Wc_Tut_Start_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_start_h = /** @type {((inputs?: Wc_Tut_Start_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Start_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_start_h(inputs)
});
export { wc_tut_start_h as "wc.tut.start.h" }